export default __webpack_public_path__ + "static/media/spark_43.71f2cc63.png";